/* eslint-disable no-unused-vars */
import { NotificationModal } from 'components';

export const MaxActiveBannersModal = ({ isOpen, onClose, maxActiveBanners }) => {
  if (!isOpen) return null;
  return (
    <NotificationModal
      id='11disconnect'
      iconType={NotificationModal.iconTypes.info}
      iconSign='i'
      onConfirm={onClose}
      confirmBtnType={NotificationModal.btnTypes.PrimaryNormal}
      confirmBtnText='Ok'
    >
      Active creatives are limited to {maxActiveBanners}, please disable one of the active creatives
    </NotificationModal>
  );
};
